export class SecurityCredit {
    constructor(public data: {
        StartTime?: String,
        EndTime?: String,
        Age?: Number,
        Gender?: String,
        PaymentFrequency?: Number,
        CigarettesPerDay?: Number,
        Height?: Number,
        Weight?: Number,
        OneTimePayment?: Boolean,
        PaymentPeriodMonths?: Number,
        Interest?: Number,
        CreditAmount?: Number
    }) { }
}